import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ProcessService } from 'src/app/service/process.service';
import { Router } from "@angular/router";
import { NotifierService } from 'angular-notifier';

import swal from 'sweetalert2';
import { InstanceService } from 'src/app/service/instance.service';
import { InstanceModel } from 'src/app/model/instance.model';
import { ComponentBase } from 'src/app/main/dynamic/component-base';
import { AuthenticationService } from 'src/app/service/auth.service';
import { WorkflowGatewayService } from 'src/app/service/workflow-gateway.service';

import { NgxSpinnerService } from 'ngx-spinner';
import { AttributeModel } from 'src/app/main/dynamic/model/attribute.model';
import { AttributeService } from 'src/app/main/dynamic/service/attribute.service';
import { OptionModel } from 'src/app/main/dynamic/model/option.model';
import { DynamicEvent } from 'src/app/main/dynamic/dynamic.event';
import { ValidationStrategyFactory } from 'src/app/strategy/validation-strategy.factory';
import { ProcessModel } from 'src/app/model/process.model';

@Component({
  selector: 'app-section',
  templateUrl: './section.component.html',
  styleUrls: ['./section.component.scss'],
  animations: [
    trigger('fadeAnimation', [
      state('in', style({opacity: 1})),
      transition(':enter', [
        style({opacity: 0}),
        animate(400)
      ]),
      transition(':leave',
        animate(200, style({opacity: 0})))
    ])
  ]
})
export class SectionComponent extends ComponentBase implements OnInit {

  private isAutoSaving = false;

  [x: string]: any;
  currentTab: string;
  listAttribute: Array<string> = JSON.parse(sessionStorage.getItem("listAttribute"));
  stringAttribute: string = sessionStorage.getItem("listAttribute");
  policies: AttributeModel = JSON.parse(sessionStorage.getItem("policies"));
  percent: string = this.getPercent();
  action: string;
  updateDate: Date
  @Input() currentStep : InstanceModel
  @Output() executionRequest: EventEmitter<AttributeModel[]> = new EventEmitter()

  constructor(
    private processService: ProcessService,
    private router: Router,
    private notifier: NotifierService,
    private instanceService: InstanceService,
    private attrService: AttributeService,
    private authService: AuthenticationService,
    private workflowApi: WorkflowGatewayService,
    private spinner: NgxSpinnerService) {
    super()
  }

  get isAdmin(): boolean {
    return this.authService.hasRole("admin")
  }

  get shouldShowFinishButton(): boolean {
    let nextStep = this.getNextStep(this.currentTab)

    return nextStep == "complete"
  }

  ngOnInit() {
    this.currentTab = sessionStorage.getItem('stepCurrent')
  }

  autoSave(update?: boolean) {
    if (this.isAutoSaving) {
      return;
    }

    let timeout = setTimeout(() => {
      this.spinner.show();
    }, 400);

    this.isAutoSaving = true;

    let isNew = this.processService.isNew
    this.processService.saveAttribute(this.attribute)
      .subscribe(() => {
        clearTimeout(timeout);
        if(isNew) {
          window.history.replaceState({}, '',
            '/processes/process/edit/' +
            sessionStorage.getItem('idPolicy') + '/' +
            sessionStorage.getItem('processId'))
        }

        this.updateDate = new Date()
        this.showNotification('default', 'Salvo');

        if(update) {
          this.emit({
            name: "save and update"
         })
        } else {
          this.spinner.hide();
        }

        this.isAutoSaving = false;
      }, (error)=> {
        clearTimeout(timeout);
        this.handleHttpError(error);
        this.isAutoSaving = false;
      })
  }

  dynamicOnEmit(events: DynamicEvent[]){
    events.forEach(e => this.processEvent(e))
  }

  private processEvent(event: DynamicEvent) {
    if(!event || !event.name) {
      return;
    }

    if(event.name == "validate") {
      ValidationStrategyFactory.create(this.attribute).validate()
    } else if (event.name == "autosave") {
      this.autoSave()
    } else if (event.name == "save and update") {
      this.autoSave(true)
    } else if (event.name == "task" || event.name == "toggletask" || event.name.startsWith("action")) {
      this.emitExecution(event);
    }
  }

  private async emitExecution(event: DynamicEvent) {
    while (this.isAutoSaving) {
      await new Promise(resolve => setTimeout(resolve, 100));
    }

    this.spinner.show();
    
    this.executionRequest.emit([event.attribute]);
  }

  public showNotification(type: string, message: string): void {
    this.notifier.notify(type, message);
  }

  getTask(): AttributeModel {
    let defaultTask = new AttributeModel()
    defaultTask.key = "Finalizar Cadastro"
    defaultTask.type = "Task"

    if(!this.currentStep) {
      return defaultTask
    }

    let task = this.currentStep.attributes
      .find(attr => attr.type.toLowerCase() == "task")

    if(task) {
      return task
    }

    return defaultTask
  }

  getTaskName(): string {
    return this.getTask().key
  }

  save(callback?: () => any) {
    let isNew = this.processService.isNew

    this.processService.saveAttribute(this.attribute)
      .subscribe(() => {
        this.saveTasksRequirements()

        if(isNew) {
          this.router.navigate([
            '/processes/process/edit/' +
            sessionStorage.getItem('idPolicy') + '/' +
            sessionStorage.getItem('processId')]);
        }

        this.emit({
          name: "save and update"
        })

        if(callback) {
          callback()
        }
      }, (error)=> this.handleHttpError(error))
  }

  private saveTasksRequirements() {
    let tasks: AttributeModel[] = []

    this.fillTaskList(this.attribute.attributes, tasks)

    if (tasks.length > 0) {
      this.instanceService
        .updateAttribute(tasks, this.processService.processModel.id)
        .subscribe(()=> {
          this.showNotification('default', 'Salvo');
        }, (error)=> this.handleHttpError(error))
    } else {
      this.showNotification('default', 'Salvo');
    }
  }

  fillTaskList(attributes: AttributeModel[], tasks: AttributeModel[]) {
    if (!attributes) {
      return
    }

    for (const attr of attributes) {
      let taskOpt = this.attrService.getOptionBy(attr, "task")

      if (taskOpt) {
        this.addActivationTaskAttr(attr, tasks);
      }

      this.fillTaskList(attr.attributes, tasks)
    }
  }

  private addActivationTaskAttr(attr: AttributeModel, tasks: AttributeModel[]) {
    let task = new AttributeModel();
    task.key = attr.key;
    task.value = attr.value;
    task.type = "Task";

    let required = new OptionModel();
    required.key = "Required";
    required.value = attr.value ? "True" : "False";
    required.type = "Boolean";

    let disabled = new OptionModel();
    disabled.key = "Disabled";
    disabled.value = attr.value ? "False" : "True";
    disabled.type = "Boolean";
    task.options = [required, disabled];

    tasks.push(task);
  }

  getNextStep(stepCurrent: string): string {
    let index = this.listAttribute.findIndex(item => item == stepCurrent);
    let indexNextStep: number;

    if (index > -1) {
      indexNextStep = index + 1;
    } else if (this.listAttribute.length > 0) {
      return "0";
    }
    else {
      return null;
    }

    if (indexNextStep < this.listAttribute.length) {
      return this.listAttribute[indexNextStep]
    }
    else if (indexNextStep == this.listAttribute.length) {
      if(this.processService.isFirstStepEqualsCurrent()) {
        return "complete";
      }
      else {
        return this.listAttribute[indexNextStep-1]
      }
    }
  }

  async onContinue(current: string) {
    let action: string = this.getNextStep(current);

    if (action != 'complete') {
      this.currentTab = action;
      sessionStorage.setItem('stepCurrent', this.currentTab);
      setTimeout(() => {
        this.save();
      }, 200);
    } else {
      await this.onExecute()
    }

    window.scrollTo(500, 0);
  }

  validate(): boolean {
    let isValid: boolean = true;

    isValid = this.processService.validate()

    return isValid;
  }

  async onExecute(attr?: AttributeModel) {
    while (this.isAutoSaving) {
      await new Promise(resolve => setTimeout(resolve, 100));
    }

    // Se não foi passado um atributo, usamos a tarefa padrão (finalizar)
    const actionAttribute = attr || this.getTask();

    const isAction = (actionAttribute.type || '').toLowerCase().startsWith('action');
    const isTask = (actionAttribute.type || '').toLowerCase() == 'task';

    // Para ações, pular validação; para tarefas, validar
    if (!isAction && !this.validate()) {
      swal.fire('Atenção', 'Existem campos obrigatórios não preenchidos; por favor, preencha os campos em vermelho.', 'warning');
      let botao = swal.getConfirmButton();
      botao.addEventListener('click', this.onGotoBegin.bind(this));
      return;
    }

    const previousStepId = this.currentStep ? this.currentStep.id : null;
    const processModel = this.processService.processModel;

    this.spinner.show();

    let requestAttributes: AttributeModel[] = [];
    requestAttributes.push(actionAttribute);
    requestAttributes.push(this.attribute);

    this.instanceService.executeById(processModel.id, requestAttributes)
      .subscribe((response: ProcessModel) => {
        this.spinner.hide();

        const newStepId = response && response.currentStep ? response.currentStep.id : null;
        const stepChanged = previousStepId && newStepId && previousStepId !== newStepId;

        if (isTask && stepChanged) {
          this.showFinalMessages();
        } else {
          this.showNotification('default', 'Ação realizada com sucesso');
        }

      }, (error) => {
        this.spinner.hide();
        this.registryHttpErrorHandler(error);
      });
  }

  private showFinalMessages() {
    swal.fire({
      title: 'Sucesso',
      text: "Cadastro realizado com sucesso.",
      icon: 'success',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Ir para listagem',
      confirmButtonText: 'Visualizar detalhes'
    }).then((result) => {
      console.log(result);
      if (result.value) {
        this.router.navigateByUrl('/processes/scope/view/' + sessionStorage.getItem('idPolicy') + '/' + sessionStorage.getItem('processId'));
      }
      else {
        this.router.navigateByUrl('/dashboard');
      }
    })
  }

  getTasksAndActions(): AttributeModel[] {
    if (!this.currentStep || !this.currentStep.attributes) {
      return [];
    }
    return this.getTasksFromList(this.currentStep.attributes);
  }

  private getTasksFromList(attributes: AttributeModel[]): AttributeModel[] {
    if (!attributes) {
      return [];
    }

    return attributes.filter(attr => {
      const type = (attr.type || '').toLowerCase();
      const isTaskOrAction = type == 'task' || type == 'actionbutton' || type.startsWith('action');
      const isHidden = (attr.options || [])
        .some(opt => opt.key && opt.key.toLowerCase() == 'view' && opt.value == 'hide');
      return isTaskOrAction && !isHidden;
    });
  }

  // removed duplicate onExecute

  onContinueLater() {
    this.spinner.show();

    this.save(() =>
    {
      this.instanceService.executeById(this.processService.processModel.id, [])
                          .subscribe(() => {
                            this.navigateToDashboard();
                            this.spinner.hide();
                          }, (error)=> this.handleHttpError(error));

    });
  }

  onDelete() {
    swal.fire({
      title: 'Atenção',
      text: "Deseja realmente excluir?",
      icon: 'info',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Não',
      confirmButtonText: 'Sim'
    }).then((result) => {
      console.log(result);
      if (result.value) {
        this.delete();
      }
    })
  }

  private delete() {
    this.workflowApi.deleteProcess(this.processService.processModel.id)
      .subscribe(() => {
        this.navigateToDashboard()
      }, (error)=> this.handleHttpError(error))
  }

  navigateToDashboard() {
    this.router.navigateByUrl('/dashboard');
  }

  onGotoBegin() {
    this.selectStep(this.listAttribute[0])
  }

  selectStep(selectStep: string) {
    this.currentTab = selectStep;
    sessionStorage.setItem('stepCurrent', this.currentTab);

    this.save(() => {
      $('.progress-bar').attr('style', 'width:' + this.getPercent() + '%');
      window.scrollTo(500, 0);
    });
  }

  getPosition(policy: string): string {
    let indexPolicy = this.listAttribute.findIndex(item => item == policy) + 1;
    let stepCurrent: string = sessionStorage.getItem('stepCurrent');
    let indexCurrent = this.listAttribute.findIndex(item => item == stepCurrent) + 1;
    $('.progress-bar').attr('style', 'width:' + this.getPercent() + '%');
    if (policy == stepCurrent)
      return 'wizard-step wizard-step--current';
    else {
      if (indexPolicy < indexCurrent)
        return 'wizard-step wizard-step--current';
      else
        return 'wizard-step';
    }
  }

  getPercent(): string {
    let total: number = this.listAttribute.length;
    let stepCurrent: string = sessionStorage.getItem('stepCurrent');
    let indexCurrent: number = this.listAttribute.findIndex(item => item == stepCurrent);
    return (indexCurrent / (total - 1) * 100).toString().replace(',', '.');
  }

  getIconClass(child: AttributeModel): string {
    if (!child.options)
      return null;

    let icon = child.options.find(option => option.key == 'Icon');

    if (icon)
      return icon.value;
  }

  getViewModeOption(attributes: AttributeModel) : OptionModel{
    let viewOpt = attributes.options.find(opt => opt.key.toLowerCase() == "viewmode")

    if(viewOpt){
      return viewOpt
    }

    return null

  }

  visibilityStep(step: string): boolean {
    if (step != sessionStorage.getItem('stepCurrent')) {
      return true;
    }
    else {
      return false;
    }
  }

  private registryHttpErrorHandler(error: any) {
    this.spinner.hide();
    if(error.status == 401) {
      this.authService.logout()
      this.router.navigate(['login']);
    } else if(error.status == 403) {
      swal.fire("Atenção", "Seu processo foi cadastrado com sucesso. Você será redirecionado para tela inicial.")
            .then(() => this.router.navigate([""]).then(() => swal.close()))
    } else if(error.message) {
      swal.fire("Atenção", error.message, "error").then(() => {
        if(error.goBackToHome) {
          this.router.navigate([""]).then(() => swal.close())
        }
      })
    } else {
      swal.fire('Atenção!', `Erro ao iniciar a execução do processo. Favor tente finalizar novamente.`, 'warning');
    }
  }

  private handleHttpError(error: any) {
    this.spinner.hide();

    if(error.status == 401) {
      this.authService.logout()
      this.router.navigate(['login']);
    } else if(error.status == 403) {
      swal.fire("Atenção", "Este usuário não tem permissão para acessar este conteúdo.")
        .then(() => this.router.navigate([""]).then(() => swal.close()))
    } else if(error.message) {
      swal.fire("Atenção", error.message, "error").then(() => {
        if(error.goBackToHome) {
          this.router.navigate([""]).then(() => swal.close())
        }
      })
    } else {
      swal.fire("Atenção", "Algo errado aconteceu; Por favor, tente novamente.", "error")
    }
  }
}
